import UserTypes from './user.types';
import UserState from './user.state';
import { UserAction } from './user.actions';

export default function (state: UserState | null = null, action: UserAction): UserState | null {
    switch (action.type) {
        case UserTypes.USER_LOADED:
            return { ...state!, ...action.payload };
        case UserTypes.GET_QUICK_CONNECTS:
            return { ...state!, connects: action.payload };
        case UserTypes.USER_AVAILABLE:
            return { ...state!, afterCallWork: false, error: false };
        case UserTypes.AFTER_CALL_WORK:
            return { ...state!, afterCallWork: true };
        case UserTypes.AFTER_CALL_WORK_END:
            return { ...state!, afterCallWork: false };
        case UserTypes.CALL_ISSUE:
            return { ...state!, callIssue: true };
        case UserTypes.SHOW_QUICK_CONNECTS:
            return { ...state!, showConnects: true };
        case UserTypes.TOGGLE_QUICK_CONNECTS:
            return { ...state!, showConnects: !state!.showConnects };
        case UserTypes.HIDE_QUICK_CONNECTS:
            return { ...state!, showConnects: false };
        case UserTypes.USER_ERROR:
            return { ...state!, error: true };
        case UserTypes.REFRESH:
            return { ...state!, error: false };
        case UserTypes.FETCH_AGENT_STATS:
            return { ...state!, agentContactStatsByQueue: action.payload };
        case UserTypes.SET_TIME_RANGE:
            return { ...state!, timeRange: action.payload };
        case UserTypes.USER_SET_STATE:
            return { ...state!, inStateSince: new Date() }
        case UserTypes.SET_AFTER_CALL_STATUS:
            return { ...state!, afterCallStatus: action.payload }
        case UserTypes.USER_AUTHENTICATED:
            if (!state) return state;
            return { ...state, agentID: action.payload.agentID }
        case UserTypes.SET_LOGOUT_COUNTDOWN:
            return { ...state!, logoutCountDown: action.payload };
        case UserTypes.SET_SHOW_NEXT_STATUS:
            return { ...state!, showNextStatus: action.payload };
        case UserTypes.SET_STATUS_CONTROL:
            return { ...state!, statusControl: action.payload };
        case UserTypes.LOGOUT:
            return null;
        default:
            return state;
    }
}
